/**
 * Add callback to run on page visibility loss or shutdown. This event will run on visibilityChange when available if it
 * is not available then pageHide and then beforeUnload.
 */
export function addShutdownEvent(callback) {
    if ('visibilityState' in document) {
        const callbackWrapper = () => {
            if (document.visibilityState === 'hidden') {
                callback();
            }
        };
        document.addEventListener('visibilitychange', callbackWrapper);
    }
    else if ('onpagehide' in window) {
        window.addEventListener('pagehide', callback);
    }
    else if ('onbeforeunload' in window) {
        window.addEventListener('beforeunload', callback);
    }
}
//# sourceMappingURL=addShutdownEvent.js.map